import * as Sentry from '@sentry/react';
import api from 'api';

import getProjectId from 'utils/url/getProjectId';
import fetchRunDetails from 'store/fetchRunDetails';
import fetchTaskDetails from 'store/fetchTaskDetails';
import fetchWorkflowProgress from 'store/fetchWorkflowProgress';

export default function killTask(runId: string, taskId: string) {
  const projectId = getProjectId();
  if (!projectId) return Promise.reject(new Error('No project ID'));

  return api
    .post(`projects/${projectId}/workflows/${runId}/tasks/${taskId}/operations`, {
      json: { type: 'KILL' },
    })
    .json()
    .then(
      () => {
        fetchTaskDetails(runId, taskId);
        fetchRunDetails(runId);
        fetchWorkflowProgress(runId);
      },
      (error) => {
        Sentry.captureException(error);
        throw error;
      },
    );
}
